import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const SubmenuDesktop = ({ menu, submenu, visible }) => {
  const handleTag = (eventLabel) => {
    if (window && window.dataLayer)
      window.dataLayer.push({
        'event': 'institucional_header',
        'action': 'clicou_btn',
        'clique': eventLabel
      })
  }

  return (
    <>
      <S.SubmenuDesktop
        visible={visible}
        id='SubmenuDesktop-ul'
        className='SubmenuDesktop-ul'
        data-testid='submenudesktop-ul'
      >
        {submenu.map((subitem, index) => (
          <S.SubmenuItem
            key={index}
            id='SubmenuItem-li'
            className='SubmenuItem-li'
            data-testid='submenuitem-li'
          >
            <S.SubmenuLink
              id='SubmenuLink-a'
              className='SubmenuLink-a'
              data-testid='submenulink-a'
              data-item-text={`${menu} > ${subitem.title}`}
              data-item-position="Menu Header"
              data-current-service="Home"
              href={subitem.url}
              onClick={() => handleTag(submenu.title)}
            >
              {subitem.title}
            </S.SubmenuLink>
          </S.SubmenuItem>
        ))}
      </S.SubmenuDesktop>
    </>
  )
}

SubmenuDesktop.propTypes = {
  submenu: PropTypes.array,
  visible: PropTypes.bool,
}

export default SubmenuDesktop
